import {Component, OnInit} from '@angular/core';
import {Popover} from 'primeng/popover';
import {Router} from '@angular/router';
import {AvatarComponent} from '../avatar/avatar.component';
import {AuthService} from '../../core/services/auth-service/auth.service';
import {User} from '../../interfaces/loginInterface';
import {UserService} from '../../core/services/user-service/user.service';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [
    Popover,
    AvatarComponent
  ],
  providers: [AuthService],
  templateUrl: './header.component.html',
  styleUrl: './header.component.css'
})
export class HeaderComponent implements OnInit {
  user: User | null = null;
  popOverData = [
    {label: 'Profile', action: 'profile'},
    {label: '2FA', action: '2fa'},
    {label: 'Logout', action: 'logout'}
  ];

  constructor(
    private authService: AuthService,
    private userService: UserService,
    private router: Router,
  ) {
  }

  ngOnInit() {
    this.userService.getUser().subscribe({
      next: user => {
        this.user = user;
      }
    });
  }

  logout() {
    this.authService.logout();
  }

  handlePopoverClick(action: string) {
    switch (action) {
      case 'logout':
        this.logout();
        break;
      case 'profile':
        this.router.navigate(['/profile']);
        break;
      case '2fa':
        console.log('2FA clicked');
        break;
    }
  }

}
